import { ContainerComponent, wrap } from 'AppReact';
import { SecondaryTextSmBold } from 'atoms';
import { Td, Tr, Px5, Px4, FlexCenterJustifyEndWrapper, WhiteSpaceNoWrap } from 'wrappers';

export const definition = {
  name: 'ColumnNamesRow',
  controller: {},
  initialProps: ({ }) => ({}),
  props: {},
  elements: [
    {
      wrapper: Tr,
      name: 'Row',
      displayState: ({ }) => ({
        height: '48px',
        background: '#F3F5F5',
      }),
      elements: [
        {
          wrapper: Td,
          name: 'InspectionItems',
          displayState: ({ }) => ({
            borderRight: '1px solid #E3E3E3',
            borderLeft: '1px solid #E3E3E3',
          }),
          elements: [
            {
              component: wrap(wrap(SecondaryTextSmBold, Px4), WhiteSpaceNoWrap),
              name: 'InspectionItems',
              displayValue: ({ }) => 'Inspection Items',
            }
          ]
        },

        {
          wrapper: Td,
          name: 'Items',
          elements: [
            {
              component: wrap(SecondaryTextSmBold, Px5),
              name: 'Items',
              displayValue: ({ }) => 'Items',
            }
          ]
        },
        {
          wrapper: Td,
          name: 'Percentage',
          displayState: ({ }) => ({
            borderRight: '1px solid #E3E3E3',
          }),
          elements: [
            {
              component: wrap(SecondaryTextSmBold, Px5),
              name: 'Percentage',
              displayValue: ({ }) => 'Percentage',
            }
          ]
        },



        {
          wrapper: Td,
          name: 'BadItemsItems',
          elements: [
            {
              component: wrap(SecondaryTextSmBold, Px5),
              name: 'Items',
              displayValue: ({ }) => 'Items',
            }
          ]
        },
        {
          wrapper: Td,
          name: 'BadItemsPercentage',
          displayState: ({ }) => ({
            borderRight: '1px solid #E3E3E3',
          }),
          elements: [
            {
              component: wrap(SecondaryTextSmBold, Px5),
              name: 'Percentage',
              displayValue: ({ }) => 'Percentage',
            }
          ]
        },


        {
          wrapper: Td,
          name: 'Chart',
          elements: []
        },
        {
          wrapper: Td,
          name: 'Photos',
          elements: [
            {
              component: wrap(SecondaryTextSmBold, Px5),
              name: 'Photos',
              displayValue: ({ }) => 'Photos',
            }
          ]
        },

        // {
        //   wrapper: Td,
        //   name: 'Tags',
        //   elements: [
        //     {
        //       component: wrap(SecondaryTextSmBold, Px5),
        //       name: 'Tags',
        //       displayValue: ({ }) => 'Tags',
        //     }
        //   ]
        // },


        {
          wrapper: Td,
          name: 'Cost',
          displayState: ({ }) => ({
            borderRight: '1px solid #E3E3E3',
          }),
          elements: [
            {
              component: wrap(wrap(SecondaryTextSmBold, Px5), FlexCenterJustifyEndWrapper),
              name: 'Cost',
              displayValue: ({ }) => 'Cost',
            }
          ]
        },


      ]
    }
  ]
}

export default ContainerComponent(definition);
